import {
  RescheduleCountResponse,
  RescheduleFilters,
  RescheduleItem,
  RescheduleKindCounts,
} from "@myapp/contract";
import apiClient from "../../../shared/config/axios";
import { Paginated } from "../../../shared/types/IPaginationResponse";

/** The list envelope plus the per-kind totals the segments show. */
export type ReschedulePageResponse = Paginated<RescheduleItem> & {
  meta: { counts?: RescheduleKindCounts };
};

export const rescheduleApi = {
  search: (params: RescheduleFilters & { page: number }) =>
    apiClient.get<ReschedulePageResponse>("/reschedule/items", { params }),
  count: () =>
    apiClient.get<RescheduleCountResponse>("/reschedule/count"),
};
